import { Icons } from "@/components/icons";
import { buttonVariants } from "@/components/ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import {
  Drawer,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { siteConfig } from "@/lib/config";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { useState } from "react";
import { useTranslations } from "@/lib/hooks/use-translations";
import { IoMenuSharp } from "react-icons/io5";
import { LocaleSwitch } from "./ui/locale-switch";

export default function MobileDrawer() {
  const [isOpen, setIsOpen] = useState(false);
  const { t, locale } = useTranslations();

  const handleLinkClick = () => {
    setIsOpen(false); // Close drawer on link click
  };

  return (
    // Pass state and handler to the Drawer component from @/components/ui/drawer
    <Drawer open={isOpen} onOpenChange={setIsOpen}>
      <DrawerTrigger
        aria-label="Menü öffnen"
        aria-expanded={isOpen}
        aria-controls="navigation-menu"
      >
        <IoMenuSharp className="text-2xl" />
      </DrawerTrigger>
      <DrawerContent id="navigation-menu">
        <DrawerTitle className="sr-only">Navigation Menu</DrawerTitle>
        <DrawerHeader className="px-6">
          <div className="flex items-center justify-between">
            <Link
              href={siteConfig.getLocalizedUrl("/", locale)}
              title="brand-logo"
              className="relative mr-6 flex items-center space-x-2"
              onClick={handleLinkClick} // Add onClick handler
            >
              <Icons.logo className="w-auto h-[40px]" />
            </Link>
            <LocaleSwitch />
          </div>
          <nav>
            <ul className="mt-12 text-left">
              {siteConfig.header(locale).map((item, index) => (
                <li key={index} className="my-4">
                    {item.trigger ? (
                      item.content && item.content.items && item.content.items.length > 0 ? (
                        <Accordion type="single" collapsible className="border-none">
                        <AccordionItem value={`item-${index}`} className="border-none">
                          <AccordionTrigger className="py-0 font-semibold">
                            {item.trigger}
                          </AccordionTrigger>
                          <AccordionContent>
                            <ul className="pl-3 space-y-1.5">
                              {item.content.items.map((subItem, subIndex) => (
                                <li key={subIndex}>
                                  <Link
                                    href={siteConfig.getLocalizedUrl(subItem.href || "", locale)}
                                    className="text-base font-medium"
                                    onClick={handleLinkClick}
                                  >
                                    {subItem.title}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </AccordionContent>
                        </AccordionItem>
                      </Accordion>
                      ) : (
                        <span className="font-semibold">{item.trigger}</span>
                      )
                    ) : (
                      <Link
                        href={siteConfig.getLocalizedUrl(item.href || "", locale)}
                        className="font-semibold"
                        onClick={handleLinkClick} // Add onClick handler
                      >
                        {item.label}
                      </Link>
                    )}
                </li>
              ))}
            </ul>
          </nav>
        </DrawerHeader>
        <DrawerFooter>
          <Link
            href={siteConfig.getLocalizedUrl("/contact", locale)}
            className={cn(
              buttonVariants({ variant: "default" }),
              "w-full sm:w-auto text-background flex gap-2"
            )}
            onClick={handleLinkClick} // Add onClick handler
          >
            <Icons.logoIcon className="h-6 w-6" />
            {t('common.buttons.getStarted')}
          </Link>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
